import "./ModalNewSection.scss";
import { useEffect, useState } from "react";
import {
  Col,
  Row,
  Modal,
  Icon,
  Button,
  Input,
  Radio,
  Form,
  notification,
  Popover
} from "antd";
import { useTranslation } from 'react-i18next';

import { Paragraph, FieldSet, Table, Text, Section, Decision } from "../../FormDeclaration/components";

import personIcon from './img/person.png'
import entityIcon from './img/entity.png'

const ModalNewSection = ({ form, handlerAddSection }) => {
    const {t} = useTranslation('forms');
    const {getFieldDecorator, validateFields} = form;
    const [type, setType] = useState(null)
    const [section, setSection] = useState({
        id: "S" + Math.floor(Math.random() * 1000000),
        status: 'ACTIVE',
        type: null,
        components: []
    })



    const onChangeRadio = (value) => {
        setType(value)
        if (value === 2) setSection({...section, type: 'CUSTOM'})
        else setSection({...section, type: null})
    }

    const handleChangeName = (value) => {
        setSection({...section, name: value})
    }

    const handleBlockBtnAdd = () => {
        validateFields(['name', 'type']).then(() => { return true })
            .catch(() => { return false });
    }

    const handlerBtnAdd = () => {
        validateFields(['name', 'type'])
            .then(() => {
                if ((type === 1 || type === 3) && section.type === null) {
                    notification.error({
                        message: t('forms.manager.section.selectType')
                    })
                } else {
                    handlerAddSection(section)
                }
            })
            .catch((err) => {
                console.log(err)
            });
    }

    const selectTypeFields = (type) => {
        let c = getComponentNewSection(type, true)
        setSection({...section, type, components: c.components})
    }

    const getContentPopOver = (comp) => {
        return <Row className="overlayExample">
          <Col className="explain-component" span={24}>{getTextComponent(comp)}</Col>
          <Col className="component-example"span={24}>
          { (comp === 'PARAGRAPH') && 
            <Paragraph component={getComponentByType(comp)} mode="preview" lang="all" />
          }
          { (comp === 'FIELDSET') && 
            <FieldSet section={{}} parent={{}} component={getComponentByType(comp)} mode="preview" lang="all" />
          }
          { (comp === 'TABLE' || comp === 'DECL') && 
            <Table section={{}} component={getComponentByType(comp)} mode="preview" lang="all" />
          }
          { comp === 'TEXT' && 
            <Text component={getComponentByType(comp)} mode="preview" lang="all" />
          }
          { comp === 'DECISION' && 
            <Decision component={getComponentByType(comp)} mode="preview" lang="all" />
          }
          </Col>
        </Row>
    }

    const getContentPopOverSection = (s) => {
        return <Row className="overlayExample">
          <Col className="explain-component" span={24}>{getTextComponent(s)}</Col>
          <Col className="component-example"span={24}>
            <Section key={getRandomId()} section={getComponentNewSection(s)} mode="previewpop" lang="all" />
          </Col>
        </Row>
    }

    const getComponentNewSection = (type, add) => {
        if(type === 'TABLE' || type === 'DECL') {
            if(add) return { components: [getComponentByType(type, null)]}
            else return { components: [getComponentByType(type, add)], title: section.title};
        }else if(type === 'DATA') {
            if(add) return { components: [getComponentByType('PARAGRAPH', add), getComponentByType('FIELDSET', add, {addField:true})]};
            else return { title: section.title, components: [getComponentByType('PARAGRAPH', add), getComponentByType('FIELDSET', add)]};
        }else if(type === 'INTRO') {
            if(add) return { components: [getComponentByType('PARAGRAPH', add, {addFieldset: true})]};
            else return { title: section.title, components: [getComponentByType('PARAGRAPH', add, {addFieldset: true})]};
        }else if(type === 'TEXT') {
          return { title: section.title, components: [getComponentByType('PARAGRAPH', add)] };
        }else if(type === 'COMMENTS') {
          return { title: section.title, components: [getComponentByType('PARAGRAPH', add), getComponentByType('TEXT', add)] };
        }else if(type === 'DECISION') {
            return { title: section.title, components: [getComponentByType('DECISION', add)] };
        }else {
          return { components: [] };
        }
    }

    const getTooltipComponent = (c) => {
        if(c === 'PARAGRAPH') return t('forms.manager.section.tooltip.paragraph')
        else if(c === 'INTRO') return t('forms.manager.section.tooltip.paragraph')
        else if(c === 'DATA') return t('forms.manager.section.tooltip.data')
        else if(c === 'FIELDSET') return t('forms.manager.section.tooltip.data')
        else if(c === 'TABLE') return t('forms.manager.section.tooltip.table')
        else if(c === 'DECL') return t('forms.manager.section.tooltip.declaration')
        else if(c === 'TEXT') return t('forms.manager.section.tooltip.text')
        else if(c === 'COMMENTS') return t('forms.manager.section.type.COMMENTS')
        else if(c === 'SUBSECTION') return t('forms.manager.section.tooltip.subsection')
        else if(c === 'DECISION') return t('forms.manager.section.tooltip.decision')
    }

    const getTextComponent = (comp) => {
        if(comp === 'PARAGRAPH' || comp === 'INTRO') return t('forms.manager.section.description.paragraph')
        else if(comp === 'FIELDSET' || comp === 'DATA') return t('forms.manager.section.description.data')
        else if(comp === 'TABLE') return t('forms.manager.section.description.table')
        else if(comp === 'DECL') return t('forms.manager.section.description.declaration')
        else if(comp === 'TEXT') return t('forms.manager.section.description.text')
        else if(comp === 'COMMENTS') return t('forms.manager.section.description.comments')
        else if(comp === 'SUBSECTION') return t('forms.manager.section.description.subsection')
        else if(comp === 'DECISION') return t('forms.manager.section.description.decision')
    }

    const getComponentByType = (type, add=false, params={addFieldset: false}) => {
        if(type === "PARAGRAPH") {
            if(add && params.addFieldset) return { id: getRandomId(), type, fieldSet: getComponentByType('FIELDSET', add, params) }
            else if(add) return { id: getRandomId(), type }
            else return { id: getRandomId(), type, text: { all: t('forms.manager.section.exampleText') }, fieldSet: getComponentByType('FIELDSET', add) }
        }else if(type === "FIELDSET")  {
            if((add === true || add === null) && params.addField) return {id: getRandomId(), type, cols: 2, fields: [{ id: getRandomId(), key:'field1', type: 'FIELD', typeField: 'INPUT', required: true, tableVisible: true}]}
            else if(add) return {id: getRandomId(), type, cols: 2, hasTitle: params.title, fields: []}
            else return {id: getRandomId(), type, cols: 2, hasTitle: params.title, fields: [{ id: getRandomId(), key:'field1', type: 'FIELD', typeField: 'INPUT', title: { all: t('forms.manager.section.data1')}, required: true}, {id: getRandomId(), key:'field2', type: 'FIELD', typeField: 'INPUT', title: { all: t('forms.manager.section.data2')}, required: true}]}
        }else if(type === "TABLE") {
          return { id: getRandomId(), type, text: add?null:{ all: t('forms.manager.section.instructionsText')}, records:[], fieldSet: {...getComponentByType('FIELDSET', add, {addField: true, title: false}), minRows:0}}
        }else if(type === "DECL") {
          return { id: getRandomId(), type, decision: (add === null ? null : !add), text: add?null:{ all: t('forms.manager.section.instructionsText')}, records:[], fieldSet: {...getComponentByType('FIELDSET', add, {addField: true, title: false}), minRows: 1}}
        }else if(type === "TEXT") {
          return {id: getRandomId(), type, required: false, hasTitle: false}
        }else if(type === 'COMMENTS') {
          return { id: getRandomId(), type, components: [getComponentByType('PARAGRAPH', add), {id: getRandomId(), type: 'TEXT', required: true, hasTitle: false}] };
        }else if(type === "SUBSECTION") {
          return { id: getRandomId(), type, components: []}
        }else if(type === "DECISION") {
            return { id: getRandomId(), type, text: add?null:{ all: t('forms.manager.section.instructionsText')}, compSi: getComponentByType('SUBSECTION', add), compNo: getComponentByType('SUBSECTION', add)}
        }
    }

    const getRandomId = () => {
        return 'R' + Math.floor(Math.random() * 1000000);
    }
    
    return (
        <div className="form-manager-modal-new-section-body">
            <Col className="col-input-name">
                <Form.Item>
                    {getFieldDecorator('name', {
                        validateTrigger: "onChange",
                        rules:
                        [
                            { required: true, message: t('forms.errors.requiredField') }
                        ]
                    })(
                    <Input placeholder={t("forms.manager.section.new.name.placeholder")} onChange={(e) => handleChangeName(e.target.value)}/>
                    )}
                </Form.Item>
            </Col>
            <Col><h3>{t('forms.manager.section.selectType')}</h3></Col>
            <Form.Item className="item-radio-type">
                {getFieldDecorator('type', {
                    validateTrigger: "onChange",
                    rules:
                    [
                        { required: true, message: t('forms.errors.requiredField') }
                    ]
                })(
                <Radio.Group onChange={(e) => onChangeRadio(e.target.value)} value={type}>
                    <Row>
                        {/*<Col span={8}><Radio value={1}>Agrega Campos</Radio></Col>*/}
                        <Col span={12}><Radio value={3}>{t('forms.manager.section.templates.predefined')}</Radio></Col>
                        <Col span={12}><Radio value={2}>{t('forms.manager.section.customSection')}</Radio></Col>
                    </Row>
                </Radio.Group>
                )}
            </Form.Item>
            { type &&
                <Row className="box-section-type">
                    { type === 1 &&
                        <div>
                            <span className="title">{t('forms.manager.section.selectFieldsDescription')}</span>
                            
                            <Col span={8} offset={4}>
                                <div className={'section-type-box'+(section.type==='CONTACTPERSON'?' selected':'')} onClick={() => selectTypeFields('CONTACTPERSON')}>
                                    <Col>
                                        <img src={personIcon} />
                                    </Col>
                                    <Col> {t('forms.manager.section.type.CONTACTPERSON')} </Col>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className={'section-type-box'+(section.type==='CONTACTENTITY'?' selected':'')} onClick={() => selectTypeFields('CONTACTENTITY')}>
                                    <Col>
                                        <img src={entityIcon} />
                                    </Col>
                                    <Col> {t('forms.manager.section.type.CONTACTENTITY')} </Col>
                                </div>
                            </Col>
                        </div>
                    }
                    { type === 2 &&
                        <div>
                            <span className="title">{t('forms.manager.section.customSectionDescription')}</span>

                            <Row className="custom-tools">
                                <ul className="custom-tools-group-menu">
                                {["SUBSECTION", "PARAGRAPH", "FIELDSET", "DECL", "TABLE", "DECISION", "TEXT"].map(c =>
                                    <Popover content={getContentPopOver(c)} title={getTooltipComponent(c)} trigger="hover" placement="bottom">
                                    <li>
                                        <a href="#0">
                                            <span>
                                            { c === "PARAGRAPH" && <><Icon type="align-center" />&nbsp;{t('forms.manager.section.tooltip.paragraph')}</>}
                                            { c === "FIELDSET" && <><Icon type="form" />&nbsp;{t('forms.manager.section.tooltip.data')}</>}
                                            { c === "TABLE" && <><Icon type="table" />&nbsp;{t('forms.manager.section.tooltip.table')}</>}
                                            { c === "DECL" && <><Icon type="table" />&nbsp;{t('forms.manager.section.tooltip.declaration')}</>}
                                            { c === "TEXT" && <><Icon type="edit" />&nbsp;{t('forms.manager.section.tooltip.text')}</>}
                                            { c === "SUBSECTION" && <><Icon type="profile" />&nbsp;{t('forms.manager.section.tooltip.subsection')}</>}
                                            { c === "DECISION" && <><Icon type="fork" />&nbsp;{t('forms.manager.section.tooltip.decision')}</>}
                                            </span>
                                        </a>
                                    </li>
                                    </Popover>
                                    )}
                                </ul>
                            </Row>
                        </div>
                    }
                    { type === 3 &&
                        <div>
                            <span className="title">{t('forms.manager.section.chooseTemplate')}</span>

                            <Row className="row-plant-section">
                                <Col span={1}></Col>
                                {["INTRO", "DATA", "DECL", "TABLE"/*, "DECISION", "TEXT"*/, "COMMENTS"].map(c =>
                                    <Popover content={getContentPopOverSection(c)} title={getTooltipComponent(c)} trigger="hover" placement="bottom">
                                    <Col span={4} onClick={() => selectTypeFields(c)} className={'section-type-box' + (section.type === c ? ' selected':'')}>
                                        <Col>
                                            { c === "INTRO" && <Icon type="align-center" /> }
                                            { c === "DATA" && <Icon type="form" /> }
                                            { (c === "DECL" || c === 'TABLE') && <Icon type="table" /> }
                                            { c === "TEXT" && <Icon type="edit" /> }
                                            { c === "COMMENTS" && <Icon type="edit" /> }
                                            { c === "DECISION" && <Icon type="fork" /> }
                                        </Col>
                                        <Col>
                                            { c === "INTRO" && t('forms.manager.section.type.INTRO') }
                                            { c === "DATA" && t('forms.manager.section.type.DATA') }
                                            { c === "DECL" && t('forms.manager.section.type.DECL') }
                                            { c === "TABLE" && t('forms.manager.section.type.TABLE') }
                                            { c === "TEXT" && t('forms.manager.section.type.TEXT') }
                                            { c === "COMMENTS" && t('forms.manager.section.type.COMMENTS') }
                                            { c === "DECISION" && t('forms.manager.section.type.DECISION') }
                                        </Col>
                                    </Col>
                                    </Popover>
                                )}
                            </Row>
                        </div>
                    }
                </Row>
            }
            <Row className="btn-tools-add-section">
                <Col><Button type="primary" icon="plus" onClick={handlerBtnAdd} disabled={handleBlockBtnAdd && section.type===null}>{t('forms.añadir')}</Button></Col>
            </Row>
        </div>
    )
}

export default Form.create()(ModalNewSection)